import { Component, OnInit } from '@angular/core';
import { admimMenu } from '../../../config/adminMenuConfig/admin.menu';
import { MenuService } from '../../../services/utilities/menu.services';
import { Menu } from '../../../interface/menu.interface';
import { Router } from '@angular/router';
import {ApiurlsService} from '../../../services/api-urls/apiurls.service';
import {UtilityService} from '../../../services/utilities/utilities.services';
import {ApirequestService} from '../../../services/apirequest/apirequest.service';
import {HybseConfig} from '../../../config/hybse.config';


@Component({
  selector: 'hybse-admin-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {
  public exchangeAssets: any = [];
  public primaries:any = [];

  constructor(
    public _ms: MenuService,
    public route: Router,
    public _urls: ApiurlsService,
    public _utils: UtilityService,
    public _api: ApirequestService,
    public config: HybseConfig
  ) { }

  adminMenu:any = admimMenu;
  public activeMenu: number = 0;

  menuAction(menu: Menu, index) {
    this.activeMenu = index;
    if(menu.submenu.length > 0 ) {
      menu.subMenuCollapse = !menu.subMenuCollapse;
    } else {
      this.route.navigateByUrl(menu.path);
    }
    return false;
  }

  ngOnInit() {
    this.getExchangeAssets();
  }

  getExchangeAssets() {
    const data = {
      address: this.config.exchangeWallet,
      assets: 'eur,usd,chf,zar'
    };

    // this._api.fetchApiData(this._urls)
    this._api.fetchApiData(this._urls.nemBalanceUrl, data).subscribe(
      (res: any) => {
        this.exchangeAssets = res.data;
        this.primaries = this._utils.filterPrimaries(this.exchangeAssets);
      },
      error => {
      },
      () => {
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/common/sidenav/sidenav.component.ts